<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_showDetails">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["SMB"]["TNMTCR"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_showDetails = !bool_showDetails; resetPagination();">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content" id="tnmtd">
                                    <div>
                                        <CCol>
                                            <table class="custom-table custom-table-inPopUp afb-blue">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 20%;">{{ this.getLanguage["TNMT"]["TNMT"] }} {{getLanguage["PM"]["RS"]}}</th>
                                                        <th style="width: 20%;">{{ this.getLanguage["TNMT"]["TN"] }}</th>
                                                        <th style="width: 20%;">{{this.getLanguage["TNMT"]["TTY"]}}</th>
                                                        <th style="width: 20%;">{{ this.getLanguage["TNMT"]["TDR"] }}</th>
                                                        <th style="width: 20%;">{{ this.getLanguage["TNMT"]["TPIF"] }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td><span :style="renderTournamentStyle(obj_details.TS)">{{ renderTournamentCurrentStatus(obj_details.TS) }}</span></td>
                                                        <td>
                                                            <span v-if="obj_details.TRC != ''">[{{ obj_details.TRC }}] </span>
                                                            <span>{{ obj_details.TN }}</span>
                                                        </td>
                                                        <td>{{ renderTournamentType(obj_details.CDT) }}</td>
                                                        <td>
                                                            <span>
                                                                <span class="grid-line">{{ formatDateTime(obj_details.TF, "YYYY-MM-DD", "DD MMM YYYY") }}</span>
                                                                <span>{{  getLanguage["TNMT"]["T"] }} {{ formatDateTime(DisplayTournamentEndDate(obj_details.TO, true), "YYYY-MM-DD", "DD MMM YYYY") }}</span>
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <span class="grid-line">{{ getLanguage["TNMT"]["NTDR"] }} : {{ formatDateTime(obj_details.TO, "YYYY-MM-DD", "DD MMM YYYY") }}</span>
                                                            <span class="grid-line">
                                                                {{ getLanguage["TNMT"]["R"] }} : {{ obj_details.RF }} {{  getLanguage["TNMT"]["T"] }} {{ obj_details.RT }}
                                                            </span>
                                                            <span class="grid-line">{{ getLanguage["MTA"]["FTA"] }} : {{ formatNumber(obj_details.PA, 2, obj_details.CC) }}</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </CCol>
                                    </div>
                                    <div class='with_page'>
                                        <CCol>
                                            <header class="table-header">
                                                <strong>{{this.getLanguage["TNMT"]["CRLB"]}}</strong>
                                                <div class="pageBtn">
                                                    <button @click="ctrPopUpPage(+int_PopUpPage - 1)">
                                                        <span class="arrowLeft"></span>
                                                    </button>
                                                    <input class="page-control"
                                                           v-model="int_PopUpPage"
                                                           type="number"
                                                           v-shortkey.avoid
                                                           @keyup="ctrPopUpPage(+int_PopUpPage,0)" />
                                                    <span class="tableItemCount">/ {{int_PopUpTP}}</span>
                                                    <button @click="ctrPopUpPage(+int_PopUpPage + 1)">
                                                        <span class="arrowRight"></span>
                                                    </button>
                                                </div>
                                            </header>
                                            <table class="custom-table custom-table-inPopUp afb-blue" style="display: inline-table;">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 15%;">{{this.getLanguage['TNMT']['R']}}</th>
                                                        <th style="width: 15%;">{{this.getLanguage['AG']['PG']}}</th>
                                                        <th style="width: 15%;">{{this.getLanguage['GL']['AGT']}}</th>
                                                        <th style="width: 15%;">{{this.getLanguage['MEM']['U']}}</th>
                                                        <th style="width: 15%;" class="tableCtnRight">{{this.getLanguage['TNMT']['PC']}}</th>
                                                        <th style="width: 15%;" class="tableCtnRight">{{this.getLanguage['TNMT']['APA']}}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                <td colspan="100%" v-if=" arry_details.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                                                <tr v-for="(data,index) in arry_details">
                                                    <td>{{ data.R }}</td>
                                                    <td>{{ data.MAAGN }} ({{ data.MAAGP }})</td>
                                                    <td>{{ data.AGN }} ({{ data.AGP }})</td>
                                                    <td v-if="((isSENS == 1 && data.AGI == curAGI) ||isSENS == 0)" class="kema-eft" @click="CheckingMember(data.AGI,data.MI)">
                                                        <span class="grid-line">
                                                            <div class="custom_tooltip col-8 customer-td-affiliate-est">
                                                                <span v-if="data.MU.length >= 20"><marquee scrollamount="1">{{data.MU}}</marquee></span>
                                                                <span v-else>{{data.MU}}</span>
                                                                <p v-if="data.MI != 0" class="rounded-circle mx-2 my-auto" :style="(data.MOS == 1)? 'background:#00b64d;width:8px;height:8px;display: inline-block;': 'background:#ff0000 ;width:8px;height:8px;display: inline-block;'"></p>
                                                            </div>
                                                            <div class="float-right ml-1" v-if="data.MI != 0">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16"">
                                                                    <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                                                </svg>
                                                            </div>
                                                        </span>
                                                    </td>
                                                    <td v-else-if="(isSENS == 1 && data.AGI != curAGI)" class="kema-eft">
                                                        <span class="grid-line">
                                                            <div class="custom_tooltip col-8 customer-td-affiliate-est">
                                                                <span v-if="data.MU.length >= 20"><marquee scrollamount="1">{{data.MU}}</marquee></span>
                                                                <span v-else>{{data.MU}}</span>
                                                            </div>
                                                            <div class="float-right ml-1" v-if="data.MI != 0">
                                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16"">
                                                                    <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                                                </svg>
                                                            </div>
                                                        </span>
                                                    </td>
                                                    <td class="tableCtnRight">{{ formatNumber(data.TPC, 2) }}</td>
                                                    <td class="tableCtnRight">{{ formatNumber(data.PA, 2, data.CC) }}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </CCol>
                                    </div>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['GL']['NO']}}
                                            </template>
                                            <template v-else-if="header == 'CRLB'  && checkModuleAccess2(constAccessType.view)">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['TNMT']['CRLB']}}
                                            </template>
                                            <template v-else-if="header == 'TNMT'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['TNMT']['TNMT']}} {{getLanguage["PM"]["RS"]}}
                                            </template>
                                            <template v-else-if="header == 'OGN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['TNMT']['ORGN']}}
                                                <i @click="setSortTable('OGN')" :class="setSortLogo('OGN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['TNMT']['TN']}}
                                                <i @click="setSortTable('TN')" :class="setSortLogo('TN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'TTY'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['TNMT']['TTY']}}
                                            </template>
                                            <template v-else-if="header == 'TDR'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['TNMT']['TDR']}}
                                            </template>
                                            <template v-else-if="header == 'TPIF'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["TNMT"]["TPIF"] }}
                                            </template>
                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{checkModuleIndex('TNMTCR', 'R', constAccessType.view, '', -1)}} {{this.getLanguage["SMB"]["TNMTCR"]}}</h2>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="getUserInfo.AT !== 4">
                                <span class='searchLabel'>{{this.getLanguage["GL"]["AGT"]}} :</span>
                                <customtreeselect :multiple="true"
                                                  :limit="1"
                                                  valueConsistsOf="LEAF_PRIORITY"
                                                  :disable-branch-nodes="false"
                                                  :limitText="count => `+${count}`"
                                                  :options="dd_agentgroup"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["TNMT"]["TN"]}} :</span>
                                <CInput size="sm" :value="str_FV[1].FV" @change="v => {str_FV[1].FV = v; OganizerChange();} "></CInput>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['TNMT']['TTY']}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_TournamentPayoutOption"
                                            :placeholder="getLanguage['GL']['ALL']"
                                            :max-height="200"
                                            v-model="str_FV[2].FV"
                                            @input="OganizerChange"
                                            ref="CDT" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['TNMT']['ORGN']}} :</span>
                                <treeselect :multiple="false"
                                            :cacheOptions="false"
                                            :load-options="loadOrganizerOptions"
                                            :options="ddOrganizerList"
                                            :auto-load-root-options="false"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('TNMT.ORGN')"
                                            v-model="str_FV[6].FV" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" ref="search" @shortkey="newSearch()" class='searchBtn' size="sm" block color="success" @click="newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{getLanguage['SMB']['TNMTCRL']}}</strong>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'CRLB'  && checkModuleAccess2(constAccessType.view)">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PM']['LB']}}
                                    </template>
                                    <template v-else-if="header == 'TNMT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['TNMT']['TNMT']}} {{getLanguage["PM"]["RS"]}}
                                    </template>
                                    <template v-else-if="header == 'OGN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['TNMT']['ORGN']}}
                                        <i @click="setSortTable('OGN')" :class="setSortLogo('OGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['TNMT']['TN']}}
                                        <i @click="setSortTable('TN')" :class="setSortLogo('TN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TTY'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['TNMT']['TTY']}}
                                    </template>
                                    <template v-else-if="header == 'TDR'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['TNMT']['TDR']}}
                                    </template>
                                    <template v-else-if="header == 'TPIF'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["TNMT"]["TPIF"] }}
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'CRLB'  && checkModuleAccess2(constAccessType.view)">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['PM']['LB']}}
                                    </template>
                                    <template v-else-if="header == 'TNMT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['TNMT']['TNMT']}} {{getLanguage["PM"]["RS"]}}
                                    </template>
                                    <template v-else-if="header == 'OGN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['TNMT']['ORGN']}}
                                        <i @click="setSortTable('OGN')" :class="setSortLogo('OGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['TNMT']['TN']}}
                                        <i @click="setSortTable('TN')" :class="setSortLogo('TN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'TTY'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['TNMT']['TTY']}}
                                    </template>
                                    <template v-else-if="header == 'TDR'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['TNMT']['TDR']}}
                                    </template>
                                    <template v-else-if="header == 'TPIF'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["TNMT"]["TPIF"] }}
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_tcr.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_tcr">
                            <td v-for="header in reportHeaders" :key="header" scope="col">
                                <template v-if="header == 'NO'">
                                    {{ CountItem(index+1) }}
                                </template>
                                <template v-else-if="header == 'CRLB' && checkModuleAccess2(constAccessType.view)">
                                    <span id="actionBtnCol">
                                        <div v-if="checkModuleAccess2(constAccessType.view) && data.TS != 1" class="custom_tooltip">
                                            <i class="cil-description" @click="showDetails(data)"></i> <!--here View -->
                                            <span class="tooltiptext">{{ getLanguage["BTN"]["V"] }}</span>
                                        </div>
                                        <div v-else>-</div>
                                    </span>
                                </template>
                                <template v-else-if="header == 'TNMT'">
                                    <span :style="renderTournamentStyle(data.TS)">{{ renderTournamentCurrentStatus(data.TS) }}</span>
                                </template>
                                <template v-else-if="header == 'OGN'">
                                    {{ renderAgentGroupName(data.OGN, data.OGPC) }}
                                </template>
                                <template v-else-if="header == 'TN'">
                                    <span v-if="data.TRC != ''">[{{ data.TRC }}] </span>
                                    <span>{{ data.TN }}</span>
                                </template>
                                <template v-else-if="header == 'TTY'">
                                    {{ renderTournamentType(data.CDT) }}
                                </template>
                                <template v-else-if="header == 'TDR'">
                                    <span>
                                        <span class="grid-line">{{ formatDateTime(data.TF, "YYYY-MM-DD", "DD MMM YYYY") }}</span>
                                        <span>{{  getLanguage["TNMT"]["T"] }} {{ formatDateTime(DisplayTournamentEndDate(data.TO, true), "YYYY-MM-DD", "DD MMM YYYY") }}</span>
                                    </span>
                                </template>
                                <template v-else-if="header == 'TPIF'">
                                    <span class="grid-line">{{ getLanguage["TNMT"]["NTDR"] }} : {{ formatDateTime(data.TO, "YYYY-MM-DD", "DD MMM YYYY") }}</span>
                                    <span class="grid-line">
                                        {{ getLanguage["TNMT"]["R"] }} : {{ data.RF }} {{  getLanguage["TNMT"]["T"] }} {{ data.RT }}
                                    </span>
                                    <span class="grid-line">{{ getLanguage["MTA"]["FTA"] }} : {{ formatNumber(data.PA, 2, data.CC) }}</span>
                                </template>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Loading from 'vue-loading-overlay';
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import { constAccessType, loadingFullScreen, constTournamentType } from '@/modules/Constant.js'
    import $ from 'jquery'
    import Vue from 'vue'
    //Vue.use(require('vue-shortkey'))
    import draggable from 'vuedraggable';

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            draggable
        },
        data() {
            return {
                bool_showDetails: false,
                bool_showSearchBar: true,
                bool_fullLoading: false, //Loading Visible
                bool_fullScreen: loadingFullScreen, //Full Screen
                int_TI: 0,//Total Items
                int_RC: 100, //Row Count
                int_Page: 1,//current Page
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                int_PopUpTI: 0,  //PopUp Total Items
                int_PopUpRC: 100, //PopUp Row Count
                int_PopUpPage: 1,//PopUp current Page
                int_PopUpTP: 1, //PopUp Total Page
                temp_data: null,
                str_tableSortBy: "TN", //(sort the table col name)
                bool_isSort: true,
                str_FV: [{ F: "AGI_csv" }, { F: "TN" }, { F: "CDT" }, { F: "SAGI" }, { F: "RS", FV: 3 }, { F: "IR", FV: 1 }, { F: "OBAGI" }], //Filter Value
                arry_tcr: [], // tournament current ranking
                dd_agentgroup: [],//agent group option
                dd_TournamentPayoutOption: [],
                ddMemberList: [],
                obj_details: {},
                arry_details: [],
                constAccessType: constAccessType,
                defaultReportHeaders: ['NO', 'CRLB', 'TNMT', 'OGN', 'TN', 'TTY', 'TDR', 'TPIF'],
                reportHeaders: [],
                needResetHeaders: false,
                bool_isDDMV: false,
                ddOrganizerList: null,
            }
        },
        created() {
            this.reportHeaders = null;
            this.$parent.showSubMenu = 'R';
            this.$parent.showSubSubMenu = 'RS4';
            this.$parent.showActiveMenu = 'R.TNMTCR';

            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
            this.str_FV[0].FV = this.$route.query.agi;
            this.str_FV[2].FV = this.$route.query.tn;

            this.getAgentGroup();
            this.getTTList();
            if (this.getUserInfo.AT == 4) 
                this.str_FV[0].FV = "3-" + this.getUserInfo.AAGI;   //Auto fill in Agent Id
                //this.loadDefaultSubBrand(0);
            if (this.$route.path != this.$route.fullPath)
                this.getCurrentTournamentList();
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),
        },
        methods: {
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getCurrentTournamentList();
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                this.getCurrentTournamentList();
            },
            ctrPopUpPage(newPage,inputValue = 1) {                
                if (inputValue == 0) {
                    this.int_PopUpPage = Math.max(1, Math.min(newPage, this.int_PopUpTP));
                }
                else {
                    this.int_PopUpPage = (newPage > this.int_PopUpTP) ? 1 : (newPage < 1) ? this.int_PopUpTP : newPage;
                }
                if (this.temp_data != null) {
                    this.showDetails(this.temp_data);
                }
            },
            resetPagination() {
                this.temp_data = null;
                this.int_PopUpTI = 0;       //PopUp Total Items
                this.int_PopUpPage = 1;     //PopUp current Page
                this.int_PopUpTP = 1;       //PopUp Total Page
            },
            showDetails(data) {
                this.temp_data = data;
                this.arry_details = [];
                this.bool_fullLoading = true;
                this.obj_details = Object.assign(this.obj_details, data);

                var that = this;
                var path = this.getListingParamQuery(this.int_PopUpPage, this.int_PopUpRC, "", true);
                path += ("&f[RT]=" + data.RT + "&f[TI]=" + data.TI + "&f[TS]=" + data.TS + "&f[IR]=1");

                this.getDataApi(`/api/tournament/lltd?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.bool_showDetails = true;
                            that.setPopUpReportList(d.D)
                        }
                    });
            },
            AgentGroupChangefs(value) {
                this.str_FV[0].FV = null;
                if (value != undefined) {
                    if (value != "") {
                        var temp = "";
                        for (var x = 0; x < value.length; x++) {
                            if (x != 0) {
                                temp += ",";
                            }
                            var split = value[x].split("-");

                            if (split.length == 2) {
                                temp += split[1];
                            }
                            else {
                                temp += split[0];
                            }
                        }
                        this.str_FV[0].FV = temp;
                    }
                }
                this.OganizerChange();
            },
            checkModuleAccess2(type) {
                if (this.getUserInfo.AT !== 4)
                    return this.checkModuleAccess('TNMTCR', 'R', type);
                else
                    return this.checkModuleAccess('TNMTCR', 'R', type);
            },
            getTTList() {
                this.dd_TournamentPayoutOption = [{
                    id: 1,
                    label: this.getLanguage["PM"]["DLY"]
                }, {
                    id: 2,
                    label: this.getLanguage["PM"]["WLY"]
                }, {
                    id: 3,
                    label: this.getLanguage["PM"]["MLY"]
                }];
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);
                        }
                    });
            },
            CheckingMember(agi,mi){ 
                if(mi != null && mi != 0 && mi != ""){
                    let routeData = this.$router.resolve({ path:'/M/ML/CheckingMember', query:{ agi: agi, i: mi}});
                    window.open(routeData.href, '_blank');
                }
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    var agi = 0;
                    if (this.str_FV[0].FV) {
                        agi = this.str_FV[0].FV.split("-")[1];
                    }
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${agi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            getCurrentTournamentList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                for (var i = 0; i < this.str_FV.length; i++) {
                        if (this.str_FV[i].FV) {
                            if (path) {
                                path += "&";
                            }
                            if (this.str_FV[i].FA && this.str_FV[i].FV) {
                                var temp_ = "";
                                for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                    if (x != 0) {
                                        temp_ += ",";
                                    }
                                    temp_ += this.str_FV[i].FV[x];
                                }
                                path += ("f[" + this.str_FV[i].F + "]=" + temp_);
                            }
                            else if (this.str_FV[i].F == 'AGI' && this.str_FV[i].FV != '') {
                                var agi = 0;
                                var value = this.str_FV[i].FV;
                                if (value != "") {
                                    agi = value.split("-")[1];
                                }
                                path += "f[AGI]=" + agi;

                            }
                            else {
                                path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                            }
                        }
                    };

                this.getDataApi(`/api/tournament/ll?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setCurrentTournamentList(d.D);
                            that.resizeTableHead();
                        }
                    });
            },
            loadOrganizerOptions({ action, callback, instanceId }) {
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            var temp_ = "";
                            for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                if (x != 0) {
                                    temp_ += ",";
                                }
                                temp_ += this.str_FV[i].FV[x];
                            }
                            path += ("f[" + this.str_FV[i].F + "]=" + temp_);
                        }
                        else if (this.str_FV[i].F == 'AGI' && this.str_FV[i].FV != '') {
                            var agi = 0;
                            var value = this.str_FV[i].FV;
                            if (value != "") {
                                agi = value.split("-")[1];
                            }
                            path += "f[AGI]=" + agi;

                        }
                        else {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };

                this.getDataApi(`/api/tournament/organizer-ll?${path}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddOrganizerList = d.dropdownlist;
                        }
                        else {
                            that.ddOrganizerList = null;
                        }
                        callback(null, that.ddOrganizerList);
                    });
            },
            setPopUpReportList(data) {
                if (data.Items == null) {
                    this.arry_details = [];
                } else {
                    this.arry_details = data.Items;
                }
                this.int_PopUpTP = Math.max(data.TotalPages, 1);
                this.int_PopUpTI = data.TotalItems;
            },
            setCurrentTournamentList(data) {
                if (data.Items == null) {
                    this.arry_tcr = [];
                } else {
                    this.arry_tcr = data.Items;
                }
                this.int_TP = Math.max(data.TotalPages, 1);                
                this.int_TI = data.TotalItems;
             },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                } else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isSort}
                this.getCurrentTournamentList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            renderTournamentType(type) {
               return this.dd_TournamentPayoutOption[type - 1].label;
               //for (var i = 0; i < constTournamentType.length; i++) {
               //     if (constTournamentType[i].id == type)
               //         return constTournamentType[i].label;
               // }
               // return "-";
            },
            renderTournamentCurrentStatus(statusCode){
                return this.getLanguage['TNMT']['TS' + statusCode];
            },
            renderTournamentStyle(currentStatus) {
                if (currentStatus == 0) {
                    return { 'font-size': 'x-small', color: '#191919' }; 
                }
                if (currentStatus == 1) {
                    return { 'font-size': 'x-small', color: '#e8a317' }; 
                }
                else if (currentStatus == 2) {
                    return { 'font-size': 'x-small', color: '#0372ff' }; 
                }
                else if (currentStatus == 3) {
                    return { 'font-weight': 'bold', 'font-size': 'x-small', color: '#191919' }; 
                }

            },
            DisplayTournamentEndDate(tournamentEndDate, isToString = false){

                if(isToString){
                    return moment(tournamentEndDate).subtract('seconds', 1).format("YYYY-MM-DD HH:mm:ss");
                }

                return moment(tournamentEndDate).subtract('seconds', 1);
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            resetColumn(headerName) {
                var that = this;
                if (!that.checkModuleAccess2(constAccessType.view)) {
                    that.removeDefaultColumn('OGN')
                }

                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            OganizerChange() {
                this.ddOrganizerList = null;
            },
        },
        watch: {
            getLanguage() {
                this.getCurrentTournamentList();
                this.getTTList();
            },
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/TournamentCurrentRankingReport`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                                }

                                if (!that.checkModuleAccess2(constAccessType.view)) {
                                    that.removeDefaultColumn('OGN')
                                    that.removeColumn('OGN')
                                }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/TournamentCurrentRankingReport/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            }
        },

    }

</script>

<style>
    #affel .custom-table-inPopUp th {
        width: auto;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Reports/TournamentCurrentRanking.vue